import styled from "@emotion/styled";

export const SearchCheckbox = styled.input({
  height: "18px",
  width: "18px",
  ":hover": { outline: "5px solid GREY", outlineStyle: "auto" },
  margin: "0px",
});
